import { MyAccountPageEnum } from 'libs/core/src/lib/enum/my-account-page.enum';

export class MyAccountOption {
  public page: MyAccountPageEnum;
  public useInMenu = false;
  public order?: number;
}
